import type { ReactNode } from "react"

import { cn } from "@productlane/lib/src/cn"

interface StickySectionHeaderProps {
	children: ReactNode
	/** Drop the top border so it doesn't double the page header's bottom border. */
	flush?: boolean
}

export const StickySectionHeader = ({
	children,
	flush = false,
}: StickySectionHeaderProps) => {
	return (
		<div
			className={cn(
				"sticky top-0 z-10 flex flex-row items-center justify-between border-gray-200 bg-gray-100/60 px-6 py-2 text-sm font-medium backdrop-blur-sm dark:border-gray-700/50 dark:bg-gray-850/95",
				flush ? "border-b" : "border-y",
			)}
		>
			{children}
		</div>
	)
}
